import React, { useEffect, useRef } from "react";
import { TextContainer, Headline } from "../styles/components/Global/Text";
import animations from "./Animations";

const HeadingText = ({ text, width, align, textAlign, parallax }) => {
  const containerRef = useRef(null);
  useEffect(() => {
    if (parallax) {
      setTimeout(() => {
        animations.parallax(containerRef.current);
      }, 1000);
    }
  }, []);
  return (
    <TextContainer ref={containerRef} $align={align} $flex>
      <Headline
        $width={width}
        $textAlign={textAlign}
        dangerouslySetInnerHTML={{ __html: text }}
      ></Headline>
    </TextContainer>
  );
};

HeadingText.defaultProps = {
  width: "large",
  align: "flex-start",
  textAlign: "left",
  parallax: true,
};

export default HeadingText;
